import { Box, IconButton } from '@mui/material';
import React from 'react';
import CopyIcon from '@/public/icons/copy.svg';
import { Body2 } from '@/components/@IntranetLibrary/Typography';
import { useTranslation } from 'react-i18next';

const SignatureCardHeader = ({
  title,
  copyButtonOnClick,
}: {
  title: string;
  copyButtonOnClick: () => void;
}) => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '12px',
      }}
    >
      {title && <Body2 sx={{ flex: 1 }}>{title}</Body2>}
      <IconButton
        disableRipple
        onClick={copyButtonOnClick}
        sx={{
          display: 'flex',
          gap: '4px',
          width: 'auto',
          padding: 0,
          margin: '0 0 0 auto',
        }}
      >
        <CopyIcon
          width={'20'}
          height={'20'}
          viewBox={'0 0 16 16'}
          stroke="black"
        />
        <Body2 sx={{ color: 'black' }}>{t('복사')}</Body2>
      </IconButton>
    </Box>
  );
};

export default SignatureCardHeader;
